import { useState, useEffect, useCallback } from 'react';
import { radarApi } from '../services/api';
import { transformApiDataToRadarFormat } from '../utils/dataTransformers';

export const useRadarData = ({ skip = false } = {}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(!skip);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (skip) {
      setLoading(false);
      return;
    }
    
    try {
      setLoading(true);
      const apiData = await radarApi.getHierarchy();
      const transformedData = transformApiDataToRadarFormat(apiData);
      setData(transformedData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [skip]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refresh: fetchData
  };
}; 
